import React, { createContext, useState } from "react";

const UrlServicesContext = createContext();
const { Provider, Consumer } = UrlServicesContext;

function UrlServicesProvider({ children }) {
  /* ### RUTAS DE IMAGEN PARA USUARIOS */
  const [urlImgServices] = useState(
    "https://economiacircular.red/images/perfilusuario/"
  );

  /* ### CONSULTA DE SERVICIOS */
  const [urlServices] = useState("https://conecta2api.economiacircular.red/");
  const [keyAplication] = useState("3Yf6ovzf8E9J1xauYu2O");

  return (
    <Provider value={{ urlServices, urlImgServices, keyAplication }}>
      {children}
    </Provider>
  );
}

export {
  UrlServicesProvider,
  Consumer as urlServicesConsumer,
  UrlServicesContext,
};
